module.exports = __webpack_public_path__ + "static/img/bg_card.9c151af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_card.png
// module id = buk+
// module chunks = 1